import { render, staticRenderFns } from "./indexRepairComplaint.vue?vue&type=template&id=060b7602&scoped=true"
import script from "./indexRepairComplaint.vue?vue&type=script&lang=js"
export * from "./indexRepairComplaint.vue?vue&type=script&lang=js"
import style0 from "./indexRepairComplaint.vue?vue&type=style&index=0&id=060b7602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b7602",
  null
  
)

export default component.exports